import { DynamicObjectInterface } from '../type';
import { axiosDelete, axiosGet, axiosPost, axiosPut } from './axiosUtils';
import './axiosInterceptor';

const intermediateMeasurementService = {
  async addIntermediateMeasurement(payload: DynamicObjectInterface) {
    return await axiosPost(`intermediateMeasurement/add`, payload);
  },

  async getIntermediateMeasurement(recId: DynamicObjectInterface) {
    return await axiosGet(`intermediateMeasurement/retrieve/${recId}`);
  },

  async getIntermediateMeasurementList(payload: DynamicObjectInterface) {
    return await axiosPost(`intermediateMeasurement/list`, payload);
  },

  async updateIntermediateMeasurement(recId: DynamicObjectInterface, payload: DynamicObjectInterface) {
    return await axiosPut(`intermediateMeasurement/update/${recId}`, payload);
  },

  async deleteIntermediateMeasurement(recId: DynamicObjectInterface) {
    return await axiosDelete(`intermediateMeasurement/delete/${recId}`);
  },
};
export default intermediateMeasurementService;
